__turbopack_context__.v({
  "icon": "NewProducerMarker-module-scss-module__q8D9yG__icon",
  "inner": "NewProducerMarker-module-scss-module__q8D9yG__inner",
  "is-active": "NewProducerMarker-module-scss-module__q8D9yG__is-active",
  "location": "NewProducerMarker-module-scss-module__q8D9yG__location",
  "photo": "NewProducerMarker-module-scss-module__q8D9yG__photo",
  "producer-card": "NewProducerMarker-module-scss-module__q8D9yG__producer-card",
  "producer-content": "NewProducerMarker-module-scss-module__q8D9yG__producer-content",
  "producer-marker": "NewProducerMarker-module-scss-module__q8D9yG__producer-marker",
  "producer-marker-card": "NewProducerMarker-module-scss-module__q8D9yG__producer-marker-card",
});
